// extracted by mini-css-extract-plugin
module.exports = {"summaryInfoList":"SummaryInfoList_summaryInfoList__3S0-J","listItems":"SummaryInfoList_listItems__2AL3i"};